<div id="canvas"
  class="rappid"
  [ngClass]="{'rappid__from-view':from==='view', 'rappid--modal':modal}"
  #canvas>
</div>